module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_HyD.c5e09408.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_HyD.png
// module id = 53
// module chunks = 0